// src/api/quotesApi.js
// Backend calls for the quote builder that go through the shared axios client
// rather than a raw fetch + window.__mspToken.
//
// The three footer actions (PDF / send / push) still use callQuoteBackend in
// MspOsApp, because they own the toast behaviour that lives there. This module
// exists for the live preview, which is a different shape of call: it fires on a
// debounce, must never toast, and needs its own cancellation.
import apiClient from "./apiClient";

/**
 * The quote document's HTML, rendered by the SAME server function the PDF and
 * the client email render from.
 *
 * ⚠ SEND THE MIGRATED SHAPE. The route rejects a quote with no `sections`
 * array with a 400 naming ensureMigrated — deliberately, because a preview
 * computed from a legacy shape would disagree with the builder beside it.
 *
 * @param {string} id      the quote id (path only — the body carries the quote)
 * @param {object} quote   ensureMigrated(quote)
 * @param {AbortSignal} [signal]  so a superseded debounce tick can be dropped
 * @returns {Promise<string>} the full HTML document
 */
export async function fetchQuotePreview(id, quote, signal) {
  const { data } = await apiClient.post(
    `/api/quotes/${encodeURIComponent(id)}/preview`,
    { quote },
    { signal }
  );
  return data?.html || "";
}

/**
 * The quote's client activity — opens, questions, and the ACCEPTANCE with its
 * frozen snapshot summary — for the builder's panel.
 *
 * Staff-authenticated (the shared axios client carries the MSAL bearer). This
 * payload names the askers and carries the accepted order list, which is why
 * it lives on /api/quotes and not on the public router.
 *
 * @returns {Promise<object>} { published:false } for a quote never sent
 */
export async function fetchQuoteActivity(id) {
  const { data } = await apiClient.get(`/api/quotes/${encodeURIComponent(id)}/view-activity`);
  return data;
}
